import axios from 'axios'
import { Place } from '../../interfaces'

export const createPlace = (place: Place) => {
  return axios.post('/data/sadarbības_partnera_vieta', place)
}
